module.exports = __webpack_public_path__ + "static/media/bannerDummy.b273363e.jpg";